<template>
  <div class="issueList"  v-show="listShow">
    <div class="addTitle">
      <span>批注列表</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <notationList ref="notationList" type="rvt" @closeAdd ="closeAdd" @openDwg="openDwg" @openDetail="openDetail" />
    </div>
  </div>
</template>

<script>
import notationList from "@/views/question/notationList.vue"
import { mapState } from "vuex"
export default {
  components:{notationList},
  data(){
    return{
      listShow:false,
    }
  },
  computed:{
    ...mapState({
      hasDwg: state => state.monge.hasDwg
    })
  },
  methods:{
    closeList(){
      this.listShow = false
    },
    openList(data){
      this.listShow = true
      this.$nextTick(()=>{
        this.$refs.notationList.init(data)
      })
    },
    //问题详情
    openDetail(item){
      this.$parent.$refs.detailNotation.init(item)
    },
    closeArea(){
      Monge.Model.Mark.clear();
      Monge.Model.Mark.deactive()
      if(this.hasDwg){
        Monge.Map.CloudNotation.clear();
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive()
      }
      this.$store.dispatch("setAnnotationList",[])
      this.listShow = false
    },
    closeAdd(){
      Monge.Model.Mark.clear();
      Monge.Model.Mark.deactive()
      this.$store.dispatch("setAnnotationList",[])
      this.listShow = false
    },
    openDwg(name){
      this.$parent.$refs.modelDwglist.openNameDwg(name)
    }
  }
}
</script>

<style lang="scss" scoped>
.issueList{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 300px;
  z-index: 15;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  .addTitle{
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    width: 100%;
    height: calc(100% - 50px);
    padding: 10px 0px;
    overflow: hidden;
  }
}
</style>